import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const storageBranchGrantsWidget: DashboardWidgetConfiguration = {
  widgetId: "storage.branch-grants",
  name: "Branches with stock access",
  description: "Branches with stock access for the selected dashboard period.",
  apps: [
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.storage-locations",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "branch_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Granted branches",
    subtext: "in the last 30 days",
    icon: "users",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
